module.exports = __webpack_public_path__ + "static/media/49_tn.957f7e0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/49_tn.jpg
// module id = 537
// module chunks = 0